(() => {
  const ROOT_SELECTOR = '[data-returns-root]';

  const textFrom = (element) =>
    [...element.querySelectorAll('p')]
      .map((paragraph) => paragraph.innerText.trim())
      .filter(Boolean)
      .join('\n\n');

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    return fallbackCopy(text);
  };

  const initCopyButtons = (root) => {
    root.querySelectorAll('[data-copy-button]').forEach((button) => {
      button.addEventListener('click', async () => {
        const target = document.getElementById(button.dataset.copyTarget);
        const status = document.getElementById(button.dataset.copyStatus);

        if (!target || !status) return;

        try {
          const copied = await copyText(textFrom(target));
          status.textContent = copied
            ? 'Formularz został skopiowany do schowka.'
            : 'Nie udało się skopiować formularza. Skopiuj tekst ręcznie.';
        } catch (error) {
          status.textContent = 'Nie udało się skopiować formularza. Skopiuj tekst ręcznie.';
          console.error('Returns copy error:', error);
        }

        window.setTimeout(() => {
          status.textContent = '';
        }, 4000);
      });
    });
  };

  const initChat = (root) => {
    const button = root.querySelector('[data-returns-chat]');
    if (!button) return;

    button.addEventListener('click', () => {
      const trigger = document.getElementById('Avada-FAQ_WidgetTrigger');

      if (trigger) {
        trigger.click();
        return;
      }

      window.setTimeout(() => {
        document.getElementById('Avada-FAQ_WidgetTrigger')?.click();
      }, 500);
    });
  };

  const initExternalWidget = (root) => {
    const wrapper = root.querySelector('[data-returns-external-widget]');
    if (!wrapper) return;

    const scriptUrl = wrapper.dataset.scriptUrl;
    const bannerId = wrapper.dataset.bannerId;

    if (!scriptUrl || !bannerId || !document.getElementById(bannerId)) return;

    const existing = [...document.scripts].find(
      (script) => script.src === new URL(scriptUrl, window.location.href).href
    );

    if (existing) return;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.dataset.returnsWidget = 'true';
    document.head.appendChild(script);
  };

  const init = (root) => {
    if (!root || root.dataset.returnsInitialized === 'true') return;

    initCopyButtons(root);
    initChat(root);
    initExternalWidget(root);

    root.dataset.returnsInitialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector(ROOT_SELECTOR));
  });
})();
